class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    const megamenuContainer = document.getElementsByTagName("details")

    let megaMenuOpened = false;
    Promise.all([...megamenuContainer].map((megamenu) => {
      if (megamenu.hasAttribute('open'))
        megaMenuOpened = true
    }))

    if (megaMenuOpened == true) {
      this.header.style.setProperty('background-color', 'white')
    } else {
      if (window.scrollY > 50) {
        this.header.style['background-color'] = "white"
        // document.getElementsByTagName("localization-form")[0].children[0].getElementsByTagName("button")[0].style.setProperty("color", 'var(--aveine-blue')
        // document.getElementsByClassName("header-wrapper")[0].children[0].getElementsByTagName("span")[0].style.setProperty("color", 'var(--aveine-blue')
        // document.getElementsByClassName("header__icons")[0].children[0].getElementsByTagName("svg")[0].style.setProperty("color", 'var(--aveine-blue')
      } else {
        this.header.style['background-color'] = null 
        // document.getElementsByTagName("localization-form")[0].children[0].getElementsByTagName("button")[0].style.setProperty("color", "white")
        // document.getElementsByClassName("header-wrapper")[0].children[0].getElementsByTagName("span")[0].style.setProperty("color", "white")
        // document.getElementsByClassName("header__icons")[0].children[0].getElementsByTagName("svg")[0].style.setProperty("color", 'white')
      } 
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
